import { ACT_DVY_CHANGE } from "./ActionTypes";
import UserService from "../provider/user/UserService";
import {loading} from "./AppActions"

/*** ACTIONS DELIVERY BOYS ******/
export function actionGetDeliverys(filter, succesCallback, errorCallback) {
    return (dispatch, getStore) => {
			loading(true)(dispatch, getStore)
            UserService.getDeliveryBoys(filter, getStore().app.app).then((response) => {
                console.log("DELIVERY LIST", response)
                dispatch({
                    type:ACT_DVY_CHANGE,
                    props: {deliveryBoyList:response}
			})
            succesCallback()
        }).catch(errorCallback)
        .finally(()=>{loading(false)(dispatch, getStore)})
    };
}

export function actionGetActiveOrderForDelivery(deliveryId, succesCallback, errorCallback) {
    return (dispatch, getStore) => {
        loading(true)(dispatch, getStore)
        UserService.getActiveOrderForDelivery(deliveryId, getStore().app.app).then((response) => {
            console.log("ACTIVE ORDER", response)
            succesCallback(response)
            // dispatch({
            //     type:ACT_DVY_CHANGE,
            //     props: {deliveryBoyList:response}
            // })
        }).catch(errorCallback)
        .finally(()=>{loading(false)(dispatch, getStore)})
    };
}

export function actionGetOrderHistoryForDelivery(deliveryId, succesCallback, errorCallback) {
    return (dispatch, getStore) => {
        loading(true)(dispatch, getStore)
        UserService.getOrderHistoryForDelivery(deliveryId, getStore().app.app).then((response) => {
            console.log("ORDER HISTORY", response)
            succesCallback(response)
            // dispatch({
            //     type:ACT_DVY_CHANGE,
            //     props: {deliveryBoyList:response}
            // })
        }).catch(errorCallback)
        .finally(()=>{loading(false)(dispatch, getStore)})
    };
}



// WEBPACK FOOTER //
// ./src/actions/DeliveryBoyActions.js